import {
	mapActions,
	mapGetters
} from 'vuex';

import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import PageBar from '@/components/page-bar/page-bar';
import SidebarMenu from '@/domains/inbox/sidebar-menu/sidebar-menu';
import MessageReceived from '@/domains/inbox/message-received/message-received';

export default {
	state,
	actions,
	mutations,
	getters,
	name: 'inbox',
	components: {
		PageBar,
		SidebarMenu,
		MessageReceived
	},
	computed: {
		...mapGetters([
			'getMessageReceivedList'
		]),
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'getMessageRecipient',
			'putUnreadMessages'
		])
	},
	mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Caixa de Entrada'
		}]);

		/*window.parent.postMessage({
			schoolastic: {
				getNotificationQuantity: true
			}
		}, '*');

		window.addEventListener('message', (event) => {
			console.log('waiting notificationQuantity', event);

			if (event.data.schoolastic && event.data.schoolastic.notificationQuantity) {
				this.putUnreadMessages(event.data.schoolastic.notificationQuantity);
			}

		}, false);*/

	}
};



// WEBPACK FOOTER //
// ./sources/app/inbox/index.js